import axios from 'axios';
import { getAuth0TokenAuthorizationParams } from '../auth/auth0TokenParams';

const API_BASE = (import.meta.env.VITE_APP_API_BACKEND_URL ?? '').replace(
  /\/$/,
  '',
);

/**
 * Shared axios instance for QC Lite backend calls.
 *
 * Auth:
 * - An interceptor is attached by `AuthAxiosProvider` to inject
 *   `Authorization: Bearer <token>` automatically.
 */
export const qcAxios = axios.create({
  baseURL: API_BASE || undefined,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Attach Auth0 token injection interceptor.
 * @param {Function} getAccessTokenSilently
 * @returns {number} interceptor id
 */
export function attachQcAxiosAuthInterceptor(getAccessTokenSilently) {
  const interceptorId = qcAxios.interceptors.request.use(async (config) => {
    // Allow public endpoints if you want later.
    if (config?.skipAuth) return config;

    const token = await getAccessTokenSilently({
      authorizationParams: getAuth0TokenAuthorizationParams(),
    });

    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  return interceptorId;
}
